module.exports = __webpack_public_path__ + "img/remove_red_eye-24px.df6c017a.svg";